export function getSubdomain() {
  const hostname = window.location.hostname;

  const reserved = ["www", "app"];

  if (!hostname) return null;

  if (
    hostname === "localhost" ||
    hostname.startsWith("localhost:") ||
    hostname === "192.168.1.14"
  ) {
    return "bellos"; // local dev fallback
  }

  const parts = hostname.split(".");

  if (parts.length < 3) {
    return null;
  }

  const subdomain = parts[0]?.toLowerCase();

  if (!subdomain || reserved.includes(subdomain)) {
    return null;
  }

  return subdomain;
}
